var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ref-container"},[_c('router-view',{key:_vm.$route.path,attrs:{"viewPermission":_vm.viewPermission,"createPermission":_vm.createPermission,"editPermission":_vm.editPermission,"deletePermission":_vm.deletePermission}}),_c('ExportOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }